export function validateCardExpirationDate(month, year) {
  const currentDate = new Date();
  const currentYear = parseInt(currentDate.getFullYear().toString().substr(-2));
  const currentMonth = parseInt(currentDate.getMonth() + 1);

  if (year > currentYear) {
    return true;
  }

  if (year < currentYear) {
    return false;
  }

  if (month < currentMonth) {
    return false;
  } else {
    return true;
  }
}
